var _style, _switch;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#707070",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#707070;}\n\t.st1{fill:none;stroke:#707070;stroke-width:3;stroke-miterlimit:10;}\n")), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    requiredExtensions: "http://ns.adobe.com/AdobeIllustrator/10.0/",
    x: 0,
    y: 0,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M48,8C25.9,8,8,25.9,8,48c0,22.1,17.9,40,40,40s40-17.9,40-40C88,25.9,70.1,8,48,8z M30.2,77c0.5-9.6,8.6-17.9,17.8-17.9     S65.2,67.3,65.8,77c-5.2,3.2-11.3,5-17.8,5S35.4,80.2,30.2,77z M48,49.5c-4.3,0-7.8-3.5-7.8-7.8S43.7,34,48,34s7.8,3.5,7.8,7.8     S52.3,49.5,48,49.5z M71.3,72.8c-1.9-8.9-8.6-16.3-17-18.8c4.4-2.3,7.5-6.9,7.5-12.2C61.8,34.2,55.6,28,48,28     s-13.8,6.2-13.8,13.8c0,5.3,3,9.9,7.5,12.2c-8.4,2.5-15.1,9.8-17,18.8C18.1,66.6,14,57.8,14,48c0-18.7,15.3-34,34-34     s34,15.3,34,34C82,57.8,77.9,66.6,71.3,72.8z"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.d7e5dddbc2a87da5da9f87dcf33557b6.svg";
export { ForwardRef as ReactComponent };